import { render } from "./DocumentsOtherAll.vue?vue&type=template&id=59242828&scoped=true"
import script from "./DocumentsOtherAll.vue?vue&type=script&lang=js"
export * from "./DocumentsOtherAll.vue?vue&type=script&lang=js"

import "./DocumentsOtherAll.vue?vue&type=style&index=0&id=59242828&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59242828"]])

export default __exports__